import { Field, NumericInput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetGridFieldSection, WorksheetRecordGrid } from 'Components/Worksheets/Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';

let TestDefinitionGridSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const preventRemove = useSelector(pipe(createWorksheetSelector!('EmbeddedTests.Tests'), (p) => p.length <= 4));

  return (
    <WorksheetGridFieldSection name="EmbeddedTests.Tests">
      <WorksheetRecordGrid
        name="EmbeddedTests.Tests"
        orientation="horizontal"
        rowHeaderWidth={200}
        recordProps={{
          width: 130,
          heading: 'number',
          headingLabel: 'Test Number',
          preventRemove: preventRemove,
        }}
        fieldSet={[
          {
            name: 'Data.Preparation.WaterAddedTargetPercent',
            component: <Field input={<NumericInput />} simpleValue />,
          },
          {
            name: 'Data.Preparation.TestPortionMass',
            component: <Field input={<NumericInput />} simpleValue />,
          },
        ]}
      ></WorksheetRecordGrid>
    </WorksheetGridFieldSection>
  );
};

TestDefinitionGridSection = withInjectedProps(TestDefinitionGridSection);

export { TestDefinitionGridSection };
export default TestDefinitionGridSection;
